import { actionTypes as queueActionTypes } from '~/queue/reducer';
import { IdeaEvents as ideaActionTypes } from '~/content/types';

import keyWrapper from '@bufferapp/keywrapper';

export const actionTypes = keyWrapper('WELCOME_CHECKLIST', {
  SHOULD_REFETCH: 0,
  CLEAR_REFETCH: 0,
});

export const initialState = {
  shouldRefetch: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_REFETCH: {
      return { shouldRefetch: false };
    }
    case queueActionTypes.POST_SENT: {
      return { shouldRefetch: true };
    }
    case queueActionTypes.POST_CREATED: {
      return { shouldRefetch: true };
    }
    case `PUSHER_EVENT/${ideaActionTypes.IDEA_CREATED}`: {
      return { shouldRefetch: true };
    }
    default:
      return state;
  }
};

export const actions = {
  shouldRefetch: () => ({
    type: actionTypes.SHOULD_REFETCH,
  }),
  clearShouldRefetch: () => ({
    type: actionTypes.CLEAR_REFETCH,
  }),
};
